import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import {
  OrderNumber,
  OrderRefundCollectionItemResponse,
  OrderStatus,
  RefundSummaryResponse,
} from '@web/shared/module/shop';
import { AdminOrderBillingAddressResponse } from './admin-order-billing-address.response';
import { AdminOrderItemResponse } from './admin-order-item.response';
import { AdminOrderPaymentResponse } from './admin-order-payment.response';
import { AdminOrderShipmentResponse } from './admin-order-shipment.response';
import { AdminOrderInvoiceResponse } from './admin-order-invoice.response';
import { AdminOrderContextOperationsResponse } from './admin-order-context-operations.response';
import { AdminOwnerResponse } from './admin-owner.response';

@jsonObject
export class AdminOrderDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: OrderNumber;

  @jsonMember(String)
  public readonly status!: OrderStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(RefundSummaryResponse)
  public readonly refundSummary?: Nillable<RefundSummaryResponse>;

  @jsonMember(Number)
  public readonly totalItems!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminOrderBillingAddressResponse)
  public readonly billingAddress!: AdminOrderBillingAddressResponse;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(AdminOwnerResponse)
  public readonly owner?: Nillable<AdminOwnerResponse>;

  @jsonMember(AdminOrderInvoiceResponse)
  public readonly invoice?: Nillable<AdminOrderInvoiceResponse>;

  @jsonMember(AdminOrderInvoiceResponse)
  public readonly temporaryInvoice?: Nillable<AdminOrderInvoiceResponse>;

  @jsonArrayMember(AdminOrderItemResponse)
  public readonly items!: AdminOrderItemResponse[];

  @jsonArrayMember(AdminOrderPaymentResponse)
  public readonly payments!: AdminOrderPaymentResponse[];

  @jsonArrayMember(AdminOrderShipmentResponse)
  public readonly shipments?: Nillable<AdminOrderShipmentResponse[]>;

  @jsonMember(AdminOrderContextOperationsResponse)
  public readonly contextOperations!: AdminOrderContextOperationsResponse;

  @jsonMember(Date)
  public readonly paidAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly cancelledAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly completedAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly refundedAt?: Nillable<Date>;

  @jsonArrayMember(OrderRefundCollectionItemResponse)
  public readonly refunds!: OrderRefundCollectionItemResponse[];
}
